export default "__VITE_ASSET__DjI_Dycn__"